
import './App.css';
import React,{ Component  } from "react";
import Sidebar from './Component/Sidebar/sidebar';
import Main from './Component/Main/main';
import { motion } from "framer-motion"
import { render } from '@testing-library/react';
import Particles from "react-tsparticles";




class  App extends Component {
  state = {
    loading: true
  };

  componentDidMount() {
    this.fakeRequest().then(() => {
      const el = document.querySelector(".loader-container");
   
     
      if (el) {
        el.remove();  // removing the spinner element
        this.setState({ loading: false }); // showing the app
      }
    });
    const el1 = document.querySelector("body");
    el1.style.backgroundColor = '#404040';
   
  }

  fakeRequest = () => {
    
    return new Promise(resolve => setTimeout(() => resolve(), 5000));
  };
   ani = {
    hidden:{
        x:'-30vh',
        opacity:0
    },
    visible:{
        x:0,
        opacity:1,
        transition:{
            delay:0.7,duration:0.7,type:'spring'
        }
        

    }
}
 ani1 = {
  hidden:{
      x:'300vh',
      opacity:0
  },
  visible:{
      x:0,
      opacity:1,
      transition:{
          delay:2,duration:1,type:'spring'
      }
      

  }
}
render(){
  if (this.state.loading) {
    return null; //app is not ready (fake request is in process)
  }
  return (
    
    <motion.div className="App"
       style= {{position:"relative"}}
    >
      
     
      
       <div className="container">
         
       <div className="row row_cus">
       <div className="col-12 col-lg-4">
         <motion.div className="side_bar"
          variants={this.ani}
          initial='hidden'
          animate='visible'
         >
           
            <Sidebar />
         </motion.div>
       </div>
       <div className="col-12 col-lg-8">
       <motion.div className="Main"
       variants={this.ani1}
       initial='hidden'
       animate='visible'
       >
         <Main />
         </motion.div>
       </div>
       </div>
       </div>
     
   </motion.div>
   
  
  
 );

}

}

export default App;
